import { customElement, property } from 'lit/decorators.js';
import { getProjectNumberFormatted } from '../../dealer-franchisee/projects/data/project-helper-functions';
import { html } from 'lit';
import { ProjectSummaryTable, ProjectSummaryTableOptions } from './project-list-view';
import { LangProjectPicker } from '../../../localization/scripts/projects/project-picker-lang';
import { ViewProjectSummary } from '../../api/dealer-api-interface-project';
import {
  WebModuleLitTable,
  WebModuleLitTableColumnDef
} from '../../../webmodule-common/components/src/webmodule-components';
import { staleIcon } from '../../../webmodule-common/other/ui/icons/icon-notification-signal';

export interface ProjectPickerOptions extends ProjectSummaryTableOptions {
  onProjectSelected?: (projectSummary: ViewProjectSummary) => void;
  selectedProject?: ViewProjectSummary;
  clientId?: string;
}

@customElement('wm-projectsummarypickerbrowser')
export class ProjectPickerBrowser extends ProjectSummaryTable {
  onProjectSelected?: (projectSummary: ViewProjectSummary) => void;

  @property({ type: Object })
  selectedProject?: ViewProjectSummary;

  constructor(options: ProjectPickerOptions) {
    super(options);
    this.onProjectSelected = options.onProjectSelected;
    this.selectedProject = options.selectedProject;
    this.clickrows = true;
    this.selectMode = 'single';
  }

  override isDataLoadDelayed(): boolean {
    return false;
  }

  getColumns(): WebModuleLitTableColumnDef[] {
    const checkTemplate = (value: ViewProjectSummary) => {
      const checkClass = value.id === this.selectedProject?.id ? 'fa-solid fa-circle-dot' : 'fa-regular fa-circle';
      return html`<span class="ticket-owner-check">
        <i class="fa ${checkClass}"></i>
      </span>`;
    };

    return [
      {
        title: '', // no localization for empty title
        fieldName: 'id',
        sortable: false,
        classes: 'colpxmax-40 project-picker-id',
        displayValue: (_table: WebModuleLitTable, item: ViewProjectSummary) => {
          return checkTemplate(item);
        }
      },
      {
        title: () => LangProjectPicker.projectNumberTitle(),
        fieldName: 'number',
        sortable: true,
        classes: 'colpxmax-180 project-picker-number',
        displayValue: (_table: WebModuleLitTable, item: ViewProjectSummary) => {
          return this.stale(item)
            ? // eslint-disable-next-line @typescript-eslint/no-base-to-string
              `${staleIcon(false)}${getProjectNumberFormatted(item)}`
            : getProjectNumberFormatted(item);
        }
      },
      {
        title: () => LangProjectPicker.projectTitleTitle(),
        fieldName: 'title',
        sortable: true,
        classes: 'colpx-20 project-picker-title',
        displayValue: (_table: WebModuleLitTable, item: ViewProjectSummary) => {
          return item.title;
        }
      },
      {
        title: () => LangProjectPicker.clientTitle(),
        fieldName: 'clientId',
        sortable: false,
        classes: 'colpxmax-240 project-picker-client',
        displayValue: (_table: WebModuleLitTable, item: ViewProjectSummary) => {
          return this.getClientDisplayValue(item.clientId);
        }
      }
    ];
  }

  // eslint-disable-next-line @typescript-eslint/require-await
  public async rowClicked(e: CustomEvent<{ table: WebModuleLitTable; item: ViewProjectSummary }>): Promise<void> {
    e.stopImmediatePropagation();
    e.preventDefault();

    // eslint-disable-next-line @typescript-eslint/require-await
    this.eventHandler(async () => {
      this.onProjectSelected?.(e.detail.item);
      this.selectedProject = e.detail.item;
    });
  }
}
